/*
 * @Description: 公共配置
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-24 13:55:18
 * @LastEditTime: 2019-07-26 14:10:31
 */

// export const LOGISTICE_GATEWAY = '/logistice' // 门户网站网关
// export const LOGISTICE_BASEAPI = '' // 门户网站ip
// 打包
export const LOGISTICE_GATEWAY = '' // 门户网站网关
export const LOGISTICE_BASEAPI = 'http://182.45.207.150:52022'  // 门户网站iphttp://150.139.214.234:6608 'http://192.168.1.101:6608'
// export const LOGISTICE_BASEAPI = 'http://127.0.0.1:6608' // 门户网站ip

// export const AUTHORIZATION_GATEWAY = '/authorization' // 微服务登录网关
// export const AUTHORIZATION_BASEAPI = '' // 微服务登录ip
// 打包
export const AUTHORIZATION_GATEWAY = '' // 微服务登录网关
export const AUTHORIZATION_BASEAPI ='http://182.45.207.150:52023'// 微服务登录ip  www.jnwat.comhttp://150.139.214.234:6699'http://192.168.1.101:6699'
// export const AUTHORIZATION_BASEAPI = 'http://127.0.0.1:6699' // 微服务登录ip  www.jnwat.com
